module.exports = __webpack_public_path__ + "static/media/detractors.47c60769.svg";